import { useEffect } from 'react';
import { useThemeStore, type ThemeMode } from '@/stores/themeStore';

/** Read the current theme and toggle helper. */
export function useTheme() {
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  const toggle = useThemeStore((s) => s.toggle);
  return { mode, setMode, toggle };
}

/** Apply the theme to <html> by toggling the `.dark` / `.light` class. */
export function useApplyTheme(mode: ThemeMode): void {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', mode === 'dark');
    root.classList.toggle('light', mode === 'light');
    root.style.colorScheme = mode;
  }, [mode]);
}
